var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 36H0V24.75h11.25V36zM9 27H2.25v6.75H9V27z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 31.5H4.5v-2.25h2.25v2.25zM24.75 36V24.75H36V36H24.75zm9-9H27v6.75h6.75V27z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 31.5h-2.25v-2.25h2.25v2.25zM0 0h11.25v11.25H0V0zm2.25 9H9V2.25H2.25V9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 6.75H4.5V4.5h2.25v2.25zM22.5 36H18v-2.25h4.5V36zM18 27h2.25v2.25h2.25v2.25h-6.75v2.25H13.5v-4.5H18V27zM15.75 27H13.5v-2.25h2.25V27zM22.5 24.75h-2.25V22.5H13.5v-2.25h9v4.5zM2.25 15.75H4.5V18H2.25v4.5H0v-9h2.25v2.25zM6.75 22.5H4.5v-2.25h2.25v2.25z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13.5H18v2.25h-2.25V18h-4.5v4.5H9V18H6.75v-4.5H9v2.25h4.5V13.5zM22.5 18h-2.25v-4.5h2.25V18zM20.25 11.25H13.5V9H18V2.25h-4.5V0h6.75v2.25h4.5V4.5h-4.5v6.75z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 6.75H13.5V4.5h2.25v2.25zM24.75 11.25H22.5v-4.5h2.25v4.5zM33.75 6.75H27V0h2.25v4.5h4.5v2.25z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36 2.25h-4.5V0H36v2.25zM36 11.25h-2.25V9H36v2.25zM27 9h2.25v6.75h-4.5V13.5H27V9zM31.5 20.25h-2.25v2.25H27v-2.25h-2.25V18h9v2.25H36v2.25h-4.5v-2.25zM36 15.75h-4.5V13.5H36v2.25z"
  })));
}
export default SvgQrLarge;